import handleGroupingSelection from "../handlers/handleGroupingSelection.js";
const install = () => {
  window.addEventListener('molten.grouping.selection', handleGroupingSelection);
};
export default {
  install
};